import React, { useEffect } from 'react';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import { useFormikContext } from 'formik';

import useComparable from '../hooks/useComparable';

const FieldIterables = ({
  name,
  children,
  tail,
  helpers,
  paginate,
}) => {
  const ctx = useFormikContext();
  const arr = get(ctx.values, name) || [];

  useEffect(() => {
    if (tail !== undefined && helpers) {
      if (!isEqual(arr.slice(-1)[0], tail)) {
        // if last row isn't empty, push
        helpers.push(tail);
      } else if (arr.length > 1 && isEqual(arr.slice(-2)[0], tail)) {
        // if last 2 rows are empty, pop
        helpers.pop();
      }
    }
  }, [typeof tail, useComparable(arr)]);

  const [page, setPage] = React.useState(0);

  if (paginate) {
    const pageSize = 20;
    const skip = page * pageSize;
    const total = Math.ceil(arr.length / pageSize) || 0;
    const prev = page > 0;
    const next = page + 1 < total;
    const chW = `${page + 1}`.length;
    return (
      <>
        {total > 1 && (
          <div className='pagination mb-3'>
            <div
              className={`page-item${prev ? '' : ' disabled'}`}
              onClick={() => setPage(v => Math.max(v - 1, 0))}
            >
              <a href="#" className="page-link" onClick={(e) => { e.preventDefault(); }}>&lt;</a>
            </div>
            <div className="page-item">
              <div className='input-group bg-white'>
                <input
                  name="curPage"
                  className="form-control bg-transparent border-right-0 border-left-0"
                  value={`${page + 1}`}
                  onChange={(e) => {
                    const { value } = e.target;
                    const v = parseInt(value, 10);
                    if (!Number.isNaN(v)) {
                      setPage(v - 1);
                    }
                  }}
                  style={{
                    width: `calc(${chW}ch + 1.5rem)`,
                  }}
                />
                <div className="input-group-append">
                  <span
                    className="input-group-text bg-white pl-0 border-left-0"
                  >
                    / {Math.max(total, 1)}
                  </span>
                </div>
              </div>
            </div>
            <div
              className={`page-item${next ? '' : ' disabled'}`}
              onClick={() => setPage(v => Math.min(v + 1, total - 1))}
            >
              <a href="#" className="page-link" onClick={(e) => { e.preventDefault(); }}>&gt;</a>
            </div>
          </div>
        )}
        {arr.slice(skip, skip + pageSize).map((v, i) => children(v, i + skip, helpers))}
      </>
    );
  }

  return (
    <>
      {arr.map((v, i) => children(v, i, helpers))}
    </>
  );
};

export default FieldIterables;
